exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-line[data-v-44bd146e] {\n  border-bottom: 1px solid #b9b9b9;\n  padding-bottom: 10px;\n}\na[data-v-44bd146e]:hover {\n  cursor: pointer;\n}\n.loading-counter[data-v-44bd146e] {\n  z-index: 10005;\n  position: fixed;\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.content-tlist[data-v-44bd146e] {\n  border: none;\n}\n.content-filters .cof-box[data-v-44bd146e] {\n  background: none;\n}\n", ""]);

// exports
